// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'babel-polyfill';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'font-awesome/css/font-awesome.css';
import './theme/default.styl';
import './theme/nprogress.css';
import './theme/calendar.css';
import 'vuetify/dist/vuetify.min.css';
import Vue from 'vue';
import App from './App';
import Vuetify from 'vuetify';
import router from './router';
import store from './store/store';
import VeeValidate, {
  Validator
} from 'vee-validate';
import veeValidateIT from 'vee-validate/dist/locale/it';
import Vue2Filters from 'vue2-filters';
import colors from 'vuetify/es5/util/colors';
import Truncate from 'lodash.truncate';
import axios from 'axios';
import it from 'vuetify/es5/locale/it';
import apiCallsInterceptor from './apiCallsInterceptors';
import VueCookies from 'vue-cookies';
import './registerServiceWorker';

export const bus = new Vue();

apiCallsInterceptor();

Vue.config.productionTip = false;

// Global filters
Vue.filter('truncate', Truncate);

Vue.use(VeeValidate);

Vue.use(Vue2Filters);

Vue.use(VueCookies);

Validator.localize('it', veeValidateIT);

Vue.use(Vuetify, {
  lang: {
    locales: {
      it: it,
    },
    current: 'it',
  },
  theme: {
    primary: colors.lightGreen.darken3,
    secondary: colors.brown.lighten4,
    accent: colors.brown.base,
  },
  options: {
    customProperties: true,
    themeVariations: ['primary', 'secondary', 'accent'],
    extra: {
      mainToolbar: {
        color: 'primary',
      },
      sideToolbar: {},
      sideNav: 'primary',
      mainNav: 'primary lighten-1',
      bodyBg: '',
    },
  },
});

Vue.prototype.$userRoles = [{
  description: 'ADMIN',
  value: 'ADMIN',
},
{
  description: 'Utente Amministrativo',
  value: 'UTENTE_AMMINISTRATIVO',
},
{
  description: 'Resp. Sodalizio',
  value: 'RESPONSABILE_ASSOCIAZIONE',
},
{
  description: 'Associato',
  value: 'ASSOCIATO',
},
{
  description: 'Utente',
  value: 'UTENTE',
},
{
  description: 'Viewer',
  value: 'VIEWER',
},
];
// Bootstrap application components

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  axios,
  components: {
    App,
  },
  template: '<App/>'
});